import { Typography } from "@/components/kit";
import SvgIcon from "@/components/common/SvgIcon.tsx";
import { ReactNode } from "react";
import classNames from "classnames";

type EmptyStateProps = {
  title?: ReactNode;
  iconName?: string;
  svgIconClassName?: string;
  description?: ReactNode;
  descriptionClassName?: string;
  button?: ReactNode;
};
const EmptyStateWithIcon = ({
  description,
  iconName = "emptyStateApp",
  title,
  svgIconClassName = "",
  descriptionClassName,
  button,
}: EmptyStateProps) => {
  return (
    <div className="flex flex-col justify-center items-center gap-5">
      <SvgIcon
        className={`${svgIconClassName} max-w-[250px] max-h-[180px]`}
        fill={"fill-unset"}
        iconName={iconName}
      />

      <div className={"flex flex-col gap-1 justify-center items-center"}>
        {!!title && (
          <Typography
            className="max-w-[450px] text-center"
            variant={"Title5-Bold"}
            color={"text-gray-700"}
          >
            {title}
          </Typography>
        )}
        {!!description && (
          <Typography
            variant={"BodyPlus1-Regular"}
            color={"text-gray-400"}
            className={classNames(
              "max-w-[300px] text-center",
              descriptionClassName,
            )}
          >
            {description}
          </Typography>
        )}
        {button}
      </div>
    </div>
  );
};

export default EmptyStateWithIcon;
